/**
 * Product Info Drawer Functionality
 * Handles accordion behavior within the product info drawer
 * 
 * @requires Drawer (drawer.js)
 */

class ProductInfoDrawer {
  constructor() {
    this.accordionMapping = {
      'Shipping': 'Shipping',
      'Garment': 'Garment',
      'Material': 'Material'
    };
    
    this.init();
  }

  init() {
    // Wait for DOM to be fully ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Handle product info triggers
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-drawer-trigger="product-info"]');
      if (trigger) {
        e.preventDefault();
        this.handleTriggerClick(trigger);
      }
    });

    // Handle accordion toggles
    document.addEventListener('click', (e) => {
      const header = e.target.closest('[data-accordion-toggle]');
      if (header) {
        this.handleAccordionClick(header);
      }
    });

    // Reset accordions when drawer closes
    document.addEventListener('drawerClose', (e) => {
      if (e.detail?.drawerId === 'product-info') {
        this.closeAllAccordions();
      }
    });

    // Also handle overlay and close button clicks
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('drawer-overlay') || 
          e.target.closest('[data-drawer-close]')) {
        this.closeAllAccordions();
      }
    });
  }

  handleTriggerClick(trigger) {
    const linkText = trigger.textContent.trim();
    
    // Close all accordions first
    this.closeAllAccordions();
    
    // Open the drawer using the existing system
    ThemeUtils.dispatchEvent('openDrawer', {
      drawerId: 'product-info',
      position: 'right'
    });
    
    // Open matching accordion after drawer opens
    ThemeUtils.wait(150).then(() => {
      this.openMatchingAccordion(linkText);
    });
  }

  handleAccordionClick(header) {
    const accordionItem = header.closest('.accordion-item');
    if (!accordionItem) return;
    
    const isOpen = accordionItem.classList.contains('is-open');
    
    // Close all accordions
    this.closeAllAccordions();
    
    // Toggle current (only open if it was closed)
    if (!isOpen) {
      accordionItem.classList.add('is-open');
    }
  }

  openMatchingAccordion(linkText) {
    const accordionHeaders = document.querySelectorAll('[data-accordion-toggle]');
    
    for (const header of accordionHeaders) {
      const headerText = header.querySelector('span')?.textContent.trim() || '';
      const accordionItem = header.closest('.accordion-item');
      
      // Check if link text matches any of our mapping keys
      for (const [key, value] of Object.entries(this.accordionMapping)) {
        if (linkText.includes(key) && headerText.includes(value)) {
          accordionItem?.classList.add('is-open');
          return;
        }
      }
    }
  }

  closeAllAccordions() {
    document.querySelectorAll('.accordion-item.is-open').forEach(item => {
      item.classList.remove('is-open');
    });
  }
}

// Initialize
new ProductInfoDrawer();
